import { accommodationAvailabilityZodObject } from "@@/shared/acquire/accommodation-availability";
import { accommodationInventoryZodObject } from "@@/shared/acquire/accommodation-inventory";
import { accommodationQuantityZodObject } from "@@/shared/acquire/accommodation-quantity";
import { accommodationQuantityTypeZodEnum } from "@@/shared/acquire/accommodation-quantity-types";
import { accommodationRateZodObject } from "@@/shared/acquire/accommodation-rate";
import { contentBlockZodSchema } from "@@/shared/acquire/content-block";
import { extrasGroupZodSchema } from "@@/shared/acquire/extras-group";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { priceZodSchema } from "@@/shared/prices/price";
import { translatableZodSchema } from "@@/shared/translations/translation";
import { amountZodSchema } from "@@/shared/units-and-quantities/amount";
import { z } from "zod";
import {
    accommodationIdFactory,
    accommodationIdZodSchema,
} from "./accommodation-id";

// Accommodation
const accommodationZodObject = z.object({
    _id: accommodationIdZodSchema,
    _type: z.literal("ACCOMMODATION"),
    _createdAt: isoAndUnixZodSchema,

    price: priceZodSchema,
    amount: amountZodSchema,

    quantityDescriptions: z.object({
        title: translatableZodSchema,
        description: translatableZodSchema,
    }),

    quantities: z.record(
        accommodationQuantityTypeZodEnum,
        accommodationQuantityZodObject.optional(),
    ),
    availability: accommodationAvailabilityZodObject,
    inventory: z.array(accommodationInventoryZodObject),
    rates: z.array(accommodationRateZodObject),

    extrasGroups: z.array(extrasGroupZodSchema).optional(),
    contentBlocks: z.array(contentBlockZodSchema),
    hasAccess: z.boolean().optional(),
});
type Accommodation = z.infer<typeof accommodationZodObject>;

// Factory
const _accommodationFactoryParamsZodObject = accommodationZodObject.omit({
    _id: true,
    _type: true,
    _createdAt: true,
});
type FactoryParams = z.infer<typeof _accommodationFactoryParamsZodObject>;

const accommodationFactory = (params: FactoryParams) => {
    const command: Accommodation = {
        ...params,
        _id: accommodationIdFactory(),
        _type: "ACCOMMODATION",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export { accommodationFactory, accommodationZodObject };
export type { Accommodation, FactoryParams as AccommodationFactoryParams };
